'use strict';
var PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty';

var Module = angular.module('datePicker');

Module.constant('dateTimeConfig', {
    template: function (attrs, id) {
        return '' +
            '<div ' +
            (id ? 'id="' + id + '" ' : '') +
            'date-picker="' + attrs.ngModel + '" ' +
            (attrs.view ? 'view="' + attrs.view + '" ' : '') +
            (attrs.maxView ? 'max-view="' + attrs.maxView + '" ' : '') +
            (attrs.maxDate ? 'max-date="' + attrs.maxDate + '" ' : '') +
            (attrs.autoClose ? 'auto-close="' + attrs.autoClose + '" ' : '') +
            (attrs.template ? 'template="' + attrs.template + '" ' : '') +
            (attrs.minView ? 'min-view="' + attrs.minView + '" ' : '') +
            (attrs.minDate ? 'min-date="' + attrs.minDate + '" ' : '') +
            (attrs.partial ? 'partial="' + attrs.partial + '" ' : '') +
            (attrs.step ? 'step="' + attrs.step + '" ' : '') +
            (attrs.onSetDate ? 'date-change="' + attrs.onSetDate + '" ' : '') +
            (attrs.ngModel ? 'ng-model="' + attrs.ngModel + '" ' : '') +
            (attrs.firstDay ? 'first-day="' + attrs.firstDay + '" ' : '') +
            (attrs.timezone ? 'timezone="' + attrs.timezone + '" ' : '') +
            'class="date-picker-date-time"></div>';
    },
    format: 'YYYY-MM-DD HH:mm',
    views: ['date', 'year', 'month', 'hours', 'minutes'],
    autoClose: true,
    position: 'relative'
});

Module.directive('dateTimeAppend', function () {
    return {
        link: function (scope, element) {
            element.bind('click', function () {
                element.find('input')[0].focus();
            });
        }
    };
});

Module.filter('resultFormat', function () {
    //處理結果的格式化.
    return function (newValue, oldValue, formatConfig) {
        // console.log("enter resultFormat");
        // console.log("newValue:",newValue);
        // console.log("oldValue:",oldValue);
        var result = '';
        var newValueDate = Date.parse(newValue);
        var oldValueDate = Date.parse(oldValue);
        if (!newValueDate) {
            if (oldValueDate && newValue) {
                // console.log("resultValue set as oldValue");
                result = oldValue;
            }
            else if (formatConfig.getDefault) {
                // console.log("checking default");
                result = formatConfig.defaultValue
                    ? formatConfig.defaultValue
                    : moment(new Date()).format(formatConfig.format);
            }
            else {
                result = '';
            }
        }
        else if (!(moment.isMoment(newValue))) {
            // console.log("normale Setting,newValue is not moment");
            result = moment(newValue, formatConfig.format).format(formatConfig.format);
        }
        else {
            // console.log("normale Setting,newValue is moment");
            result = formatConfig.timezone
                ? moment.tz(newValueDate, formatConfig.timezone).format(formatConfig.format)
                : moment(newValue).format(formatConfig.format);
        }
        // console.log("end resultFormat...result", result);
        return result;
    };
});
Module.directive('dateTime', ['$compile', '$timeout', '$document', '$filter', 'dateTimeConfig', '$parse', 'datePickerUtils',
    function ($compile, $timeout, $document, $filter, dateTimeConfig, $parse, datePickerUtils) {
        var body = $document.find('body');
        // var dateFilter = $filter('mFormat');
        var dateFilter = $filter('resultFormat');

        return {
            require: 'ngModel',
            scope: {
                model: '=ngModel',
                appendAlign: '@',
                onEvent: '&'
            },
            link: function (scope, element, attrs, ngModel, $scope) {
                var configs = {
                    //有空維護這隻程式請將所屬控制類別參數改放此區塊
                    formatConfig: {
                        // 日期格式化校正設定
                        format: attrs.format || dateTimeConfig.format,
                        timezone: attrs.timezone || false,
                        getDefault: attrs.getDefault ? (attrs.getDefault === 'true') : true,
                        defaultValue: attrs.defaultValue || null,
                    },
                };
                var data = {
                    oldValue: '',
                    template: dateTimeConfig.template(attrs),
                    //有空維護這隻程式請將所屬資料類別參數改放此區塊
                };
                var format = attrs.format || dateTimeConfig.format,
                    parentForm = element.inheritedData('$formController'),
                    views = $parse(attrs.views)(scope) || dateTimeConfig.views.concat(),
                    view = attrs.view || views[0],
                    index = views.indexOf(view),
                    dismiss = attrs.autoClose ? $parse(attrs.autoClose)(scope) : dateTimeConfig.autoClose,
                    picker = null,
                    pickerID = element[0].id,
                    position = attrs.position || dateTimeConfig.position,
                    container = null,
                    minDate = null,
                    minValid = null,
                    maxDate = null,
                    maxValid = null,
                    timezone = attrs.timezone || false,
                    eventIsForPicker = datePickerUtils.eventIsForPicker,
                    dateChange = null,
                    shownOnce = false,
                    dateRequired;
                //===Main==
                init();
                //=========
                function logicInit() {
                    if (!scope.appendAlign) {
                        scope.appendAlign = 'down';
                    }
                    if (index === -1) {
                        views.splice(index, 1);
                    }
                    views.unshift(view);

                    if (angular.isDefined(attrs.minDate)) {
                        setMin(datePickerUtils.findParam(scope, attrs.minDate));

                        ngModel.$validators.min = function (value) {
                            //If we don't have a min / max value, then any value is valid.
                            return minValid ? moment.isMoment(value) && (minDate.isSame(value) || minDate.isBefore(value)) : true;
                        };
                    }

                    if (angular.isDefined(attrs.maxDate)) {
                        setMax(datePickerUtils.findParam(scope, attrs.maxDate));

                        ngModel.$validators.max = function (value) {
                            return maxValid ? moment.isMoment(value) && (maxDate.isSame(value) || maxDate.isAfter(value)) : true;
                        };
                    }

                    if (angular.isDefined(attrs.dateChange)) {
                        dateChange = datePickerUtils.findFunction(scope, attrs.dateChange);
                    }

                    if (pickerID) {
                        scope.$on('pickerUpdate', function (event, pickerIDs, data) {
                            if (eventIsForPicker(pickerIDs, pickerID)) {
                                if (picker) {
                                    //Need to handle situation where the data changed but the picker is currently open.
                                    //To handle this, we can create the inner picker with a random ID, then forward
                                    //any events received to it.
                                } else {
                                    var validateRequired = false;
                                    if (angular.isDefined(data.minDate)) {
                                        setMin(data.minDate);
                                        validateRequired = true;
                                    }
                                    if (angular.isDefined(data.maxDate)) {
                                        setMax(data.maxDate);
                                        validateRequired = true;
                                    }

                                    if (angular.isDefined(data.minView)) {
                                        attrs.minView = data.minView;
                                    }
                                    if (angular.isDefined(data.maxView)) {
                                        attrs.maxView = data.maxView;
                                    }

                                    attrs.view = data.view || attrs.view;

                                    if (validateRequired) {
                                        ngModel.$validate();
                                    }
                                    if (angular.isDefined(data.format)) {
                                        format = attrs.format = data.format || dateTimeConfig.format;
                                        ngModel.$modelValue = -1; //Triggers formatters. This value will be discarded.
                                    }
                                    // getTemplate();
                                }
                            }
                        });
                    }

                    // getTemplate();
                    element.change();
                }
                function init() {
                    //console.log("dateTime...ngModel:", ngModel);
                    //todo anson為了自訂datePicker需要新增一筆以上才能通過驗証
                    scope.$watch(attrs.dateRequired, function (value) {
                        if (!value) {
                            ngModel.$invalid = true;
                        }
                    });
                    scope.$on('setDate', function (event, date, view) {
                        setDateProcess(event, date, view);
                    });
                    scope.$on('hidePicker', function () {
                        element.triggerHandler('blur');
                    });
                    scope.$on('$destroy', clear);
                    element.bind('focus', showPicker);
                    element.bind('blur', clear);
                    element.change(function () {
                        // console.log("enter change event");
                        // console.log("scope.model:",scope.model);
                        // console.log(" data.oldValue:", data.oldValue);
                        var resultDate = dateFilter(scope.model, data.oldValue, configs.formatConfig);
                        element.val(resultDate);
                        scope.model = resultDate;
                        data.oldValue = resultDate;
                        if (dateChange) {
                            dateChange(attrs.ngModel, scope.model);
                        }
                        // console.log("scope.model:", resultDate);
                        // console.log("scope:", scope);
                        // console.log("end change event");
                    });
                    logicInit();
                }

                function setDateProcess(event, date, view) {
                    //console.log("detect setDate on");
                    //console.log("viewValue set:", date);
                    scope.model = date;
                    element.change();
                    event.stopPropagation();
                    if (attrs.minView === view) {
                        if (dismiss && views[views.length - 1] === view) {
                            clear();
                        }
                        element.blur();
                    }
                }
                function parser(viewValue) {
                    //console.log("parser viewValue:", viewValue);
                    var parsed = moment(viewValue, format);
                    var result = undefined;
                    if (parsed.isValid()) {
                        result = parsed;
                    }
                    //console.log("parser result:", result);
                    return result;
                }

                function setMin(date) {
                    minDate = date;
                    attrs.minDate = date ? date.format() : date;
                    minValid = moment.isMoment(date);
                }

                function setMax(date) {
                    maxDate = date;
                    attrs.maxDate = date ? date.format() : date;
                    maxValid = moment.isMoment(date);
                }

                function clear() {
                    // return;
                    // console.log("enter clear...picker:", picker, "container:", container);
                    if (picker) {
                        picker.remove();
                        picker = null;
                    }
                    if (container) {
                        container.remove();
                        container = null;
                    }
                    // console.log("end clear...picker:", picker, "container:", container);
                }

                // function getTemplate() {
                //     template = dateTimeConfig.template(attrs);
                // }

                function showPicker() {
                    if (picker) {
                        return;
                    }
                    var bodyHeight = document.body.scrollHeight;
                    // create picker element
                    picker = $compile(data.template)(scope);
                    picker.css({
                        display: 'block',
                        position: position,
                    });
                    picker.bind('mousedown', function (evt) {
                        evt.preventDefault();
                    });
                    scope.$digest();

                    // move picker below input element
                    if (position === 'absolute') {
                        body.append(picker);
                        $timeout(function () {
                            //這段可能會有BUG
                            //BUG原因是scope.$digest()其實還沒跑完(這方法好像是非同步)
                            //因此要徹底解決需要找到後置的處理方案
                            var width = 400;
                            if (body.width() < width) {
                                width = body.width() - 10;
                            }
                            var pos = element[0].getBoundingClientRect();
                            var pickerHeight = picker.height();
                            var height = pos.height || element[0].offsetHeight;// Support IE8
                            var scrollHeight = body.scrollTop();
                            var showTop = pos.top + height + scrollHeight;
                            if ((showTop + pickerHeight) > bodyHeight) {
                                showTop = bodyHeight - pickerHeight;
                            }

                            picker.css({
                                top: showTop + 'px',
                                left: pos.left + 'px',
                                position: position,
                                width: width + 'px'
                            });
                        }, 50);
                    } else {
                        // relative
                        container = angular.element('<div style="min-width:0px;" date-picker-wrapper></div>');
                        element[0].parentElement.insertBefore(container[0], element[0]);
                        container.append(picker);
                        picker.css({ top: element[0].offsetHeight + 'px', display: 'block' });
                    }
                    // console.log("scope.appendAlign:", scope.appendAlign);
                    // console.log("top:", element[0].offsetHeight);
                    // console.log("picker",picker);
                    // console.log("picker.height:", picker.height());
                    // console.log("container",container);
                    // console.log("container.height:", container.height());
                }


            }
        };
    }]);
